import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import scrollLock from 'scroll-lock';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var SidebarService = /** @class */ (function () {
    function SidebarService(router) {
        this.router = router;
        this.htmlElement = document.getElementsByTagName('html');
        this.visitedSidebars = [];
        this.currentSidebar = null;
        this.sidebarConfirmedSource = new Subject();
        this.sidebarClosedSource = new Subject();
        this.sidebarConfirmed$ = this.sidebarConfirmedSource.asObservable();
        this.sidebarClosed$ = this.sidebarClosedSource.asObservable();
        this.params = [];
        this.isOpen = new BehaviorSubject(false);
        this.showLoading = new BehaviorSubject(false);
    }
    SidebarService.prototype.confirmSidebar = function (data) {
        this.sidebarConfirmedSource.next(data);
    };
    SidebarService.prototype.closeSidebar = function (saved) {
        if (typeof this.confirmation == 'function' && this.confirmation) {
            this.confirmation(false, true);
        }
        else {
            this.close(saved);
        }
    };
    SidebarService.prototype.close = function (saved) {
        var _d;
        this.params = []; // clear parameters
        var key = _.head(this.currentSidebar); // from phase 1
        this.isOpen.next(false);
        this.isSidebarOpen = false;
        // from phase 1
        if (!_.isNil(saved)) {
            this.sidebarClosedSource.next((_d = {}, _d[key] = !_.isNil(saved) ? saved : false, _d));
        }
        else {
            this.sidebarClosedSource.next(true);
        }
        this.htmlElement[0].classList.remove('no-scroll');
        this.visitedSidebars = [];
        this.currentSidebar = null;
        this.router.navigate([{ outlets: { sidebar: null } }], { queryParamsHandling: 'merge', replaceUrl: true });
        // Enable scroll on body again
        scrollLock.show();
        setTimeout(function () { return scrollLock.show(); }, 100);
    };
    SidebarService.prototype.showLoadingAndCloseSidebar = function () {
        var _this = this;
        this.showLoading.next(true);
        setTimeout(function () {
            _this.showLoading.next(false);
            _this.closeSidebar();
        }, 1200);
    };
    SidebarService.prototype.previousSidebar = function () {
        if (this.visitedSidebars.length === 0) {
            this.closeSidebar();
        }
        else {
            var previous = this.visitedSidebars.pop();
            this.router.navigate([
                {
                    outlets: { sidebar: previous }
                }
            ], {
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
            this.currentSidebar = previous;
        }
    };
    SidebarService.prototype.openSidebar = function (route, params) {
        if (route === void 0) { route = []; }
        this.isOpen.next(true);
        this.isSidebarOpen = true;
        this.sidebarClosedSource.next(false);
        // Disable scroll on body
        this.htmlElement[0].classList.add('no-scroll');
        scrollLock.hide();
        if (route && route.length) {
            var sidebarParams_1 = {};
            sidebarParams_1 = route.find(function (r) { return _.isObject(r); });
            var urlParams_1 = this.INDRA_getParameters();
            if (sidebarParams_1) {
                Object.keys(sidebarParams_1).forEach(function (param) {
                    urlParams_1[param] = sidebarParams_1[param];
                });
            }
            this.router.navigate([
                { outlets: { sidebar: route } }
            ], {
                queryParams: urlParams_1,
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
        }
        // added to be able to pass parameters to specific sidebars
        this.params = [];
        if (params && params.length) {
            this.params = params;
        }
        if (this.currentSidebar) {
            this.visitedSidebars.push(this.currentSidebar);
        }
        this.currentSidebar = route;
    };
    SidebarService.prototype.INDRA_getParameters = function () {
        var urlParams = {
            'market': null,
            'language': null,
            'origin': null,
            'destination': null,
            'flightType': null,
            'adt': null,
            'chd': null,
            'inf': null,
            'yth': null,
            'depDate': null,
            'retDate': null,
            'uh': null,
            'networkName': null,
            'promocode': null,
            'voucher': null,
            'flexibleDates': null,
            'award': null,
            'email': null,
            'tapid': null,
            'anetwork': null,
            'anetid': null,
            'utm_source': null,
            'utm_campaign': null,
            'utm_content': null,
            'utm_medium': null,
            '_a': null,
            '_b': null,
            '_c': null,
            'milesPromo': null,
            'origin1': null,
            'origin2': null,
            'origin3': null,
            'origin4': null,
            'origin5': null,
            'destination1': null,
            'destination2': null,
            'destination3': null,
            'destination4': null,
            'destination5': null,
            'depDate1': null,
            'depDate2': null,
            'depDate3': null,
            'depDate4': null,
            'depDate5': null,
            'stopoverCode': null,
            'stopoverCode1': null,
            'country': null,
            'country1': null,
            'days': null,
            'days1': null,
            'stopoverRoute': null,
            'stopoverRoute1': null,
            'baggageIncluded': null,
            'cabinOptions': null,
            'onlyRefundable': null,
            'directFlights': null,
            'tapAirline': null
        };
        return urlParams;
    };
    SidebarService.prototype.getSidebarParameters = function () {
        return this.params;
    };
    SidebarService.prototype.getIsSidebarOpen = function () {
        return this.isSidebarOpen;
    };
    SidebarService.ngInjectableDef = i0.defineInjectable({ factory: function SidebarService_Factory() { return new SidebarService(i0.inject(i1.Router)); }, token: SidebarService, providedIn: "root" });
    return SidebarService;
}());
export { SidebarService };
